import { reactSelectStylingConst, STYLES } from "../../../constants";

const {
  teal,
  mutedGrey,
  blackColor,
  grayColor,
  transparentColor,
} = reactSelectStylingConst;

// Styling react select for groups / stores filter
export const filterSelectStyles = {
  // Changing default style of options in react select
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? transparentColor : STYLES.AUTO,
    color: blackColor,
  }),
  control: (styles, state) => ({
    ...styles,
    minHeight: "2.5rem",
    borderRadius: "6px",
    boxShadow: "none",
    padding: "3px",
    borderColor: state.isFocused || state.isActive ? teal : mutedGrey,
    "&:hover": {
      borderColor: teal,
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    color: blackColor,
    fontWeight: 600,
  }),
  clearIndicator: (styles) => ({
    ...styles,
    color: "red !important",
    padding: "2px",
  }),
  input: (styles) => ({
    ...styles,
    color: blackColor,
  }),
  valueContainer: (styles) => ({
    ...styles,
    lineHeight: "1",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: "2px",
  }),
};

// Styling react select for advance search filter
export const searchSelectStyles = {
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? transparentColor : STYLES.AUTO,
    color: state.isDisabled ? grayColor : blackColor,
  }),
  control: (styles) => ({
    ...styles,
    boxShadow: "none",
    minHeight: "2.5rem",
    borderRadius: "6px",
    border: "0px !important",
  }),
  valueContainer: (styles) => ({
    ...styles,
    padding: "4px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    padding: "4px",
  }),
};

// Styling react select for conversation sub-filter
export const conversationSubFilterSelectStyles = {
  // Changing default style of options in react select
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isSelected ? transparentColor : STYLES.AUTO,
    color: state.isDisabled ? grayColor : blackColor,
  }),
  control: (styles, state) => ({
    ...styles,
    minHeight: "2.5rem",
    borderRadius: "6px",
    boxShadow: "none",
    borderColor: state.isFocused || state.isActive ? teal : mutedGrey,
    "&:hover": {
      borderColor: teal,
    },
  }),
};
